import { render } from "./WorkImages.vue?vue&type=template&id=4a78b1d3"
import script from "./WorkImages.vue?vue&type=script&lang=js"
export * from "./WorkImages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\takahashi\\Julie\\pb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__